import { IStyles } from '../models/app/IStyles';

export const STYLES: IStyles = {
	components: {
		app: {
			children: {
				wrapper:
				{
					font: {
						family: 'Roboto, Arial',
						size: '11px',
					},
					color: '#000000',
					overrides: [
						{
							selector: '[data-selector="charting-chartBase-wrapper"]',
							style: {
								height: '100% ',
							},
						},
						{
							selector: 'div.recharts-wrapper > svg > g.recharts-layer.recharts-cartesian-axis.recharts-yAxis.yAxis > g text',
							style: {
								fill: '#4A4A4A',
								height: '11px',
								width: '35px',
								color: '#4A4A4A',
								font: {
									size: '10px',
								},
								lineHeight: '11px',
							},
						},
						{
							selector: 'div.recharts-wrapper > svg > g.recharts-layer.recharts-cartesian-axis.recharts-xAxis.xAxis > g text',
							style: {
								fill: '#000000',
								height: '15px',
								width: '76px',
								font: {
									size: '13px',

								},
								lineHeight: '15px',
							},
						},
						{
							selector: 'div.recharts-wrapper > div > ul > li.recharts-legend-item > svg',
							style: {
								margin: {
									right: '10px !important',
								},
								width: '10px',
								height: '10px',
								lineHeight: '15px',
							},
						},
						{
							selector: 'div.recharts-wrapper > div > ul > li.recharts-legend-item > span.recharts-legend-item-text',
							style: {
								text: {
									transform: 'uppercase',
								},
								color: '#272626',
								height: '15px',
								font: {
									size: '12px',
								},
								lineHeight: '15px',
							},
						},
						{
							selector: 'div.recharts-wrapper > div.recharts-tooltip-wrapper > div.recharts-default-tooltip',
							style: {
								text: {
									transform: 'uppercase',
								},
								font: {
									size: '12px',
								},
								lineHeight: '14px',
								background: {
									color: 'rgba(251,251,251,0.9) !important',
								},
								border: {
									_value: '1px solid #BEBDBE !important',
								},
							},
						},
						{
							selector: 'div.recharts-wrapper > .recharts-surface > .recharts-active-dot > circle',
							style: {
								fill: '#FFFFFF',
								stroke: '#c21b17',
							},
						},
					],
				},
				chartHeaderWrapper: {
					display: 'flex',
					flex: {
						direction: 'row',
						wrap: 'wrap',
					},
					justifyContent: 'space-between',
					overrides: [
						{
							selector: '> div:nth-child(1)',
							style: {
							},
						},
						{
							selector: '> div:nth-child(2)',
							style: {
								justifyContent: 'flex-end',
							},
						},
					],
				},
			},
		},
	},
	theme: {
		base: {
			calendarInput: {
				children: {
					wrapper: {
						font: {
							size: '12px',
						},
						color: 'rgb(58, 64, 81)',
					},
					header: {

					},
					headerNav: {
						display: 'flex',
						flex: {
							direction: 'row',
						},
						font: {
							size: '14px',
							weight: '500',
						},
						lineHeight: '30px',

					},
					monthButtonNext: {
						border: {
							_value: 'none',
						},
						width: '30px',
						background: {
							_value: 'none',
						},
						outline: {
							_value: 'none',
						},
					},
					monthButtonPrevious: {
						border: {
							_value: 'none',
						},
						width: '30px',
						background: {
							_value: 'none',
						},
						outline: {
							_value: 'none',
						},
					},
					month: {
						padding: {
							right: '3px',
						},
						flex: {
							_value: '1',
						},
						text: {
							align: 'right',
						},
					},
					year: {
						flex: {
							_value: '1',
						},
					},
					yearInput: {
						border: {
							_value: 'none',
						},
						color: 'rgb(58,64,81)',
						width: '80px',
					},
					body: {
					},
					calendar: {
						box: {
							shadow: '0px 0px 1px rgba(0, 0, 0, 0.5);',
						},
						background: {
							color: 'white',
						},
						width: 'fit-content',
						position: 'relative',
						zIndex: '1000',
					},
					row: {

					},
					dayOfWeek: {
						lineHeight: '34px',
						width: '34px',
						height: '34px',
						display: 'inline-block',
						opacity: '0.5',
						text: {
							align: 'center',
						},
					},
					datePickerDay: {
						lineHeight: '34px',
						width: '34px',
						height: '34px',
						display: 'inline-block',
						text: {
							align: 'center',
						},
						cursor: 'pointer',
						selectors: {
							':hover': {
								background: {
									color: 'rgb(34, 114, 243)',
								},
								opacity: '0.5',
								color: 'white',
								border: {
									radius: '50%',
								},
							},
						},
					},
					datePickerDayPlaceholder: {
						selectors: {
							':hover': {
								background: {
									color: 'unset',
								},
							},
						},
						cursor: 'default',
					},
					datePickerDaySelected: {
						background: {
							color: 'rgb(34, 114, 243)',
						},
						color: 'white',
						border: {
							radius: '50%',
						},
						selectors: {
							':hover': {
								opacity: '1',
							},
						},
					},
					datePickerDayDisabled: {
						cursor: 'not-allowed',
						color: '#cccccc',
						selectors: {
							':hover': {
								color: 'unset',
								background: {
									color: 'unset',
								},
							},
						},
					},
					datePickerDayToday: {
						color: 'rgb(26, 128, 255)',
					},
					clickLayer: {
						zIndex: '999',
						position: 'fixed',
						top: '0',
						bottom: '0',
						left: '0',
						right: '0',
						background: {
							color: 'transparent',
						},
					},
				},
			},
			asOfDate: {
				children: {
					title: {
						display: 'block',
						height: '18px',
						color: '#C21B17',
						font: {
							family: 'Roboto Medium, Arial',
							size: '16px',
						},
						letterSpacing: '0.22px',
						lineHeight: '18px',
						text: {
							transform: 'uppercase',
						},
					},
					dateWrapper: {
						height: '15px',
						color: '#9B9B9B',
						font: {
							family: 'Helvetica Neue',
							size: '12px',
						},
						letterSpacing: '-0.1px',
						lineHeight: '15px',
						display: 'block',
					},
				},
			},
			clickLayer: {
				zIndex: '100',
				position: 'fixed',
				top: '0',
				bottom: '0',
				left: '0',
				right: '0',
				background: {
					color: 'transparent',
				},
			},
			dateSelection: {
				children: {
					wrapper: {
					},
					startDate: {
					},
					endDate: {
					},
					calendarDateLabel: {
						display: 'flex',
						flex: {
							_value: '1 0 90px',
						},
						margin: {
							_value: 'auto 0',
						},
					},
					calendarDateWrapper: {
						width: '300px',
						display: 'flex',
						flex: {
							direction: 'row',
						},
						margin: {
							_value: '5px 0',
						},
					},
					calendarDateValue: {
						border: {
							_value: '1px solid #ccc',
							radius: '3px',
						},
						padding: {
							_value: '4px',
						},
						display: 'flex',
						height: 'fit-content',
					},
				},
			},
			dropdown: {
				children: {
					label: {
						display: 'inline-block',
						width: '100%',
					},
					header: {
						border: {
							bottom: {
								width: '2px',
								style: 'solid',
								color: '#0075BE',
							},
						},
						position: 'relative',
						display: 'inline-block',
						lineHeight: '40px',
						width: '100%',
						padding: {
							left: '5px',
						},
						font: {
							weight: 'bold',
						},
					},
					headerTitle: {
						float: 'left',
					},
					headerIcon: {
						float: 'right',
					},
					listItems: {
						position: 'absolute',
						background: {
							color: '#FFF',
						},
						zIndex: '1000',
						listStyle: {
							type: 'none',
						},
						display: 'inline-block',
						width: '25%',
						margin: {
							_value: '0',
						},
						padding: {
							_value: '0',
						},
					},
					listItem: {
						display: 'flex',
						flex: {
							direction: 'row',
						},
						justifyContent: 'space-between',
						padding: {
							bottom: '5px',
							top: '5px',
							left: '5px',
							right: '5px',
						},
						selectors: {
							':hover': {
								background: {
									color: '#0075BE',
								},
								color: '#FFF',
							},
						},
						border: {
							bottom: {
								_value: '1px solid #D9DCE1',
							},
						},
						text: {
							align: 'right',
						},
					},
					listItemCheckboxWrapper: {
						height: '25px',
						lineHeight: '15px',
					},
					listItemLabel: {
						height: '25px',
						lineHeight: '25px',
					},

				},
			},
		},
		charting: {
			chartBase: {
				children: {
				},
			},
			chartPeriodSelection: {
				children: {
					wrapper: {
						display: 'flex',
						flex: {
							wrap: 'wrap',
						},
						// height: '30px',
						color: '#262626',
						font: {
							family: 'Roboto, Arial',
							size: '13px',
							weight: 'bold',
						},
						letterSpacing: '-0.1px',
						lineHeight: '20px',
						text: {
							align: 'center',
							transform: 'uppercase',
						},
					},
					chartPeriod: {
						background: {
							color: '#f5f5f',
						},
						cursor: 'pointer',
						margin: {
							_value: '2px',
						},
						padding: {
							_value: '5px 13px',
						},
						whiteSpace: 'nowrap',
						border: {
							radius: '4px',
							width: '1px',
							color: '#333',
							style: 'solid',
						},
						color: '#333',
					},
					activeChartPeriod: {
						background: {
							color: '#C21B17',
						},
						color: 'white',
						cursor: 'pointer',
						margin: {
							_value: '2px',
						},
						padding: {
							_value: '5px 13px',
						},
						whiteSpace: 'nowrap',
					},
					disabledChartPeriod: {
						background: {
							color: '#626366',
						},
						color: '#000',
						cursor: 'default',
						margin: {
							_value: '2px',
						},
						padding: {
							_value: '5px 13px',
						},
						whiteSpace: 'nowrap',
					},
				},
			},
		},
	},
};